import { Injectable } from '@angular/core';

export enum EStaticCategory {
  All = 'ALL',
  ZipMoneyDeals = 'ZIP_MONEY_DEALS',
  OtherDeals = 'OTHER_DEALS',
}

@Injectable()
export class GiftcardCategoryService {
  public isLoadingGiftcardCategory: boolean;
  public giftcardCategories: any;
  public giftcardCategoriesFiltering: any;
  public categoryBoxRef: any;
  public searchGiftCardsInput: string;
  public selectedCategoryId = EStaticCategory.All;

  constructor() {
    this.isLoadingGiftcardCategory = false;
    this.giftcardCategories = [];
    this.giftcardCategoriesFiltering = [];
    this.categoryBoxRef = '';
    this.searchGiftCardsInput = '';
  }

  setSelectedCategoryId(categoryId: EStaticCategory) {
    this.selectedCategoryId = categoryId;
  }

  setStateLoadingGiftcardCategory(data) {
    this.isLoadingGiftcardCategory = data;
  }

  setDataGiftcardCategories(data: any) {
    const tmp = data.result;
    const filtered = tmp.filter((value) => {
      return value.visible === true;
    });

    this.giftcardCategories = filtered;
  }

  setDataGiftcardCategoriesFiltering(data: any) {
    this.giftcardCategoriesFiltering = data;
  }

  setCategoryBoxRef(ref) {
    this.categoryBoxRef = ref;
  }

  setSearchGiftCardsInput(data: string) {
    this.searchGiftCardsInput = data;
  }
}
